import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import {
    NgForm,
    FormGroup,
    FormControl,
    FormArray,
    Validators,
    ValidatorFn,
    AsyncValidatorFn
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FormInlineRowComponent } from './../forms/form-inline-row';
import { MessageComponent, BaseComponent } from '../common/common-components';
import { DictionaryService } from "../services/dictionary-service";
import { BankAccountService } from "../accounts/bank-account-service";
import { MessageService } from "../services/message-service";
import { WalletService } from "./wallet-service";
import { UserService } from "../user/user-service";
import { ClipboardDirective } from 'ngx-clipboard';
declare var ga: any;

let _: any = require("lodash");

@Component({
    selector: 'dk-wallet-deposit',
    inputs: ['id'],
    template: require('./wallet-deposit.html'),
    entryComponents: [],
    providers: [DictionaryService, BankAccountService, WalletService, ClipboardDirective, UserService]
})

export class WalletDepositComponent extends BaseComponent implements OnInit {
    public id: number;
    public errorMessageId: string;
    public currencies: any[];
    public bankCodes: any[];
    public isSummary: boolean = false;
    public transaction: any;
    public summaryDataAccount: any;
    public summaryDataCurrency: any;
    public summaryDataCantor: any;
    public cantorBankCodeId: any;
    public amountCopied: boolean = false;
    public accountCopied: boolean = false;
    public recipientCopied: boolean = false;
    public streetCopied: boolean = false;
    public postalCodeCopied: boolean = false;
    public titleCopied: boolean = false;
    public swiftCopied: boolean = false;
    public isActive: boolean = false;
    public viewNumber: number = 1;
    public isReady: boolean = false;
    public loaded: boolean = false;
    public transactionId: string;
    public bankUrl: string;
    public bankImg: string;
    public submitLock: boolean = false;
    public showCurrencyCalculator: boolean = false;
    public bankInfo: string;
    public personalData: boolean = false;

    form: FormGroup = new FormGroup({
        CurrencyId: new FormControl('', Validators.required),
        Amount: new FormControl(null, Validators.required),
        BankCodeId: new FormControl('', Validators.required),
    });

    constructor(private dictionaryService: DictionaryService, private messageService: MessageService,
        private bankAccountService: BankAccountService, private route: ActivatedRoute, private walletService: WalletService,
        private userService: UserService) {
        super();
    }

    next() {
        this.touchFormGroup(this.form);
        if (this.form.valid) {

            this.transaction = this.form.value;
            this.errorMessageId = null;

            this.summaryDataAccount = _.find(this.bankCodes, q => q.BankCodeID == this.transaction.BankCodeId);
            this.summaryDataCurrency = _.find(this.currencies, q => q.Id == this.transaction.CurrencyId);
            this.bankAccountService.getMatchingCantorBankId(this.transaction.BankCodeId).subscribe(result => {
                this.viewNumber = 2;
                this.showCurrencyCalculator = false;
                this.summaryDataCantor = result[0];
                this.cantorBankCodeId = result[0].CantorBankCodeID;
                this.bankInfo = result[0].BankInfo;
            });

            this.bankAccountService.getImageAndUrlByName(this.summaryDataAccount.BankName).subscribe(value => {
                if (value) {
                    this.bankUrl = value.url;
                    this.bankImg = value.img;
                } else {
                    this.bankUrl = null;
                    this.bankImg = null;
                }
            });

        }
    }

    back() {
        this.viewNumber = 1;
    }

    confirm() {
        this.touchFormGroup(this.form);

        if (this.form.valid) {
            if (this.submitLock) {
                return;
            }
            this.submitLock = true;
            let item = {
                CurrencyId: this.transaction.CurrencyId,
                Amount: this.transaction.Amount,
                BankCodeId: this.transaction.BankCodeId,
                CantorBankCodeId: this.cantorBankCodeId
            };
            this.walletService.createTransactionRecharge(item).subscribe(transactionId => {
                this.transactionId = transactionId;
                this.viewNumber = 3;
                this.submitLock = false;
                ga('send', 'event', 'portfel', 'wpłata', this.selectedCurrency, item.Amount, item);
            }, (error) => {
                this.submitLock = false;
                this.errorMessageId = error.messageId;
                });
        }
    }

    public ngOnInit() {
        this.bankAccountService.isAccountActive().subscribe(result => {
            this.isActive = result;
        });

        this.bankAccountService.isAccountReadyForReacharge().subscribe(result => {
            this.isReady = result;
            this.loaded = true;
        });
        
        this.dictionaryService.accountCurrencies().subscribe(currencies => {
            if (currencies.length == 0){
                return;
            }
            
            this.currencies = currencies;
            let currencyId = this.route.snapshot.params['currencyId'];
            if (currencyId) {
                this.form.controls['CurrencyId'].setValue(currencyId);
            } else {
                this.form.controls['CurrencyId'].setValue('');
            }
        });

        this.userService.accountInfo().subscribe(result => {
            this.personalData = result;
        });

        this.form.controls['CurrencyId'].valueChanges.subscribe(newValue => {
            this.bankAccountService.bankCodesForCurrency(newValue).subscribe(bankCodes => {
                this.bankCodes = bankCodes;
                if (bankCodes[0]) {
                    this.form.controls['BankCodeId'].setValue(bankCodes[0].BankCodeID);
                }
            })
        });
    }

    public clipboardAmountCopied() {
        this.amountCopied = true;

        setTimeout(() => {
            this.amountCopied = false;
        }, 3000);
    }

    public clipboardAccountCopied() {
        this.accountCopied = true;

        setTimeout(() => {
            this.accountCopied = false;
        }, 3000);
    }

    public clipboardRecipientCopied() {
        this.recipientCopied = true;

        setTimeout(() => {
            this.recipientCopied = false;
        }, 3000);
    }

    public clipboardTitleCopied() {
        this.titleCopied = true;

        setTimeout(() => {
            this.titleCopied = false;
        }, 3000);
    }

    public clipboardStreetCopied() {
        this.streetCopied = true;

        setTimeout(() => {
            this.streetCopied = false;
        }, 3000);
    }

    public clipboardPostalCodeCopied() {
        this.postalCodeCopied = true;

        setTimeout(() => {
            this.postalCodeCopied = false;
        }, 3000);
    }

    public clipboardSwiftCopied() {
        this.swiftCopied = true;

        setTimeout(() => {
            this.swiftCopied = false;
        }, 3000);
    }

    public clipboardError() {
        alert("Przepraszamy. Nie udało się skopiować do schowka.");
    }

    public openCurrencyCalculator() {
        this.showCurrencyCalculator = true;
    }

    get rechargeTitle(): string {
        return this.transactionId;
    }

    get isSwiftVisible(): boolean {
        let result = this.transaction.CurrencyId != 1;
        return result;
    }

    get selectedCurrency(): string {
        var currencyIdControl = this.form.controls["CurrencyId"];

        if (currencyIdControl) {
            var currencyId = currencyIdControl.value;

            if (currencyId) {
                return _.find(this.currencies, q => q.Id == currencyId).Symbol;
            }
        }

        return null;
    }

    get isMbankLayout(): boolean {
        return this.summaryDataAccount.BankName == 'mBank';
    }
}
